import { extractProfileInfo } from 'components/ExternalIntegrationSelect/utils'
import Silhouette from 'components/Previews/InstagramPreview/silhouette.jpg'
import Styles from './InstagramStoryPreview.module.scss'
import { Heart } from 'blaze-ui/icons/24'
import { Send1 } from 'blaze-ui/icons'
import { InstagramIntegration } from 'api/clients/ExternalIntegrationsClient'
import { Button } from 'blaze-ui/Button'
import { Edit1 } from 'blaze-ui/icons'
import cx from 'classnames'
import { ReactNode, useState } from 'react'
import { MediaObject } from 'types'
import { MediaRenderer } from '../components/MediaRenderer/MediaRenderer'
import { DesignChannel } from 'components/NewFileModal/Types'

interface InstagramStoryPreviewProps {
  integration?: InstagramIntegration
  mediaObject?: MediaObject
  showVideoControls?: boolean
  onEdit?: () => void
  containerClassName?: string
  customPreviewContent?: ReactNode
  isActive?: boolean
  isTransitioning?: boolean
  isGenerating?: boolean
  showHoverActionOverlay?: boolean
  almanacFileKey?: string
  onClose?: () => void
}

export const InstagramStoryPreview = ({
  integration,
  showVideoControls,
  onEdit,
  containerClassName,
  customPreviewContent,
  mediaObject,
  isActive = true,
  isTransitioning = false,
  isGenerating = false,
  showHoverActionOverlay = false,
  almanacFileKey,
  onClose,
}: InstagramStoryPreviewProps) => {
  const { username, avatar } = integration ? extractProfileInfo(integration) : { username: '', avatar: Silhouette }

  const [imageFailed, setImageFailed] = useState(false)

  return (
    <div className={cx(Styles.container, containerClassName)}>
      <div className={Styles.headerContainer}>
        <div className={Styles.loadingBar}>
          <div className={Styles.progress}></div>
        </div>
        <div className={Styles.header}>
          {imageFailed ? (
            <img className={Styles.avatar} src={Silhouette} alt="Avatar" />
          ) : (
            <img
              className={Styles.avatar}
              src={avatar || Silhouette}
              alt={username}
              onError={() => setImageFailed(true)}
            />
          )}
          <span className={Styles.username}>{username}</span>
          <span className={Styles.time}>1h</span>
          {onEdit && (
            <Button variant="tertiary" onPress={onEdit} frontIcon={Edit1}>
              Edit
            </Button>
          )}
        </div>
      </div>

      <div className={Styles.content}>
        {customPreviewContent && customPreviewContent}
        {!customPreviewContent && mediaObject && (
          <MediaRenderer
            channel={DesignChannel.InstagramStory}
            mediaObject={mediaObject}
            alt="Story content"
            className={Styles.storyImage}
            showHoverActionOverlay={showHoverActionOverlay}
            almanacFileKey={almanacFileKey}
            showVideoControls={showVideoControls}
            isActive={isActive}
            onClose={onClose}
            isGenerating={isGenerating}
          />
        )}
      </div>

      <div className={Styles.footer}>
        <div className={Styles.messageInput}>
          <input type="text" placeholder="Send message..." readOnly />
        </div>
        <div className={Styles.actions}>
          <Heart />
          <Send1 />
        </div>
      </div>
    </div>
  )
}
